import React from "react";
// import { useTranslation } from "react-i18next";

import AudioMemoPlayer from "./AudioMemoPlayer"; // 20261015 음성메모 재생 UI 개선

const AudioMemoMessage = ({ indexKey, msgInfo, handleSelectUrl }) => {
    // 20261015 PLAY 버튼(항상 처음부터 재생) → 재생/일시정지/정지 + 재생시간 표시 컴포넌트로 교체
    /* const { t } = useTranslation();

    return (
        <button type="button" className="btn btn-sm mx-1 px-2 py-1" style={{ alignSelf: 'flex-start', paddingTop: '0.25rem', paddingLeft: '0.25rem', borderRadius: '0.5rem' }} title={t("재생", { ns: "classTalk" })} onClick={() => handleSelectUrl(msgInfo.kind, msgInfo.urlInfo, indexKey)}>
            {t("재생", { ns: "classTalk" })}
        </button>
    ); */

    return (
        <AudioMemoPlayer src={msgInfo.urlInfo} align="left" />
    );
}

export default AudioMemoMessage;